import { environment } from '../../environments/environment';

export const autoCloseSessionMins = 30;

// don't change
export const isProduction = environment.production;
